//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { RepeatDetailsItem } from './RepeatDetailsItem';
import { TaxInputItem } from './TaxInputItem';
import { TransactionInputItem } from './TransactionInputItem';

export class ChargeOrDiscountTransactionInputItem extends TransactionInputItem {
    EventCategoryID: string | null = null;
    TeacherID: string | null = null;
    RepeatDetails: RepeatDetailsItem | null = null;
    Taxes: TaxInputItem[] = [];

    constructor(initializer?: Partial<ChargeOrDiscountTransactionInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "ChargeOrDiscountTransactionInputItem";
}
